import { render } from "./Mindmap.vue?vue&type=template&id=6b7f6722&scoped=true"
import script from "./Mindmap.vue?vue&type=script&lang=js"
export * from "./Mindmap.vue?vue&type=script&lang=js"

import "./Mindmap.vue?vue&type=style&index=0&id=6b7f6722&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7f6722"]])

export default __exports__